import { useContext } from "react"
import { TranslationContext } from "./provider"

export default function useTranslation() {
	const context = useContext(TranslationContext)

	return (key, fallback) => {
		// const translation = context.get(key)
		const translation = context.getTranslation(context.selectedLanguage, key)
		// const translation = null

		return translation || fallback || key
	}
}